module.exports = __webpack_public_path__ + "static/media/landscape-1.1fb6285a.jpg";